import { create } from 'zustand';
import api from '../utils/api';

const useCartStore = create((set, get) => ({
  cart: null,
  totals: { subtotal: 0, discount: 0, shipping: 0, total: 0 },
  loading: false,

  fetchCart: async () => {
    try {
      const data = await api.get('/cart');
      set({ cart: data.cart, totals: data.totals });
    } catch {}
  },

  addToCart: async (productId, size, color, qty = 1) => {
    set({ loading: true });
    try {
      const data = await api.post('/cart/add', { productId, size, color, qty });
      set({ cart: data.cart, totals: data.totals, loading: false });
      return data;
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  updateQty: async (itemId, qty) => {
    const data = await api.put(`/cart/item/${itemId}`, { qty });
    set({ cart: data.cart, totals: data.totals });
  },

  removeItem: async (itemId) => {
    const data = await api.delete(`/cart/item/${itemId}`);
    set({ cart: data.cart, totals: data.totals });
  },

  applyCoupon: async (code) => {
    const data = await api.post('/cart/coupon', { code });
    set({ cart: data.cart, totals: data.totals });
    return data;
  },

  removeCoupon: async () => {
    const data = await api.delete('/cart/coupon');
    set({ cart: data.cart, totals: data.totals });
  },

  cartCount: () => get().cart?.items?.length || 0,
}));

export default useCartStore;
